import React from "react";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
// import ReactHtmlParser from "react-html-parser";
// import Calendar from "react-calendar";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.js";
// import "assets/scss/custom/calendar.css";
// import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(styles);

export default function CalendarAlert(props) {
  const {
    showAlert,
    alertProps,
    shippingInfo,
    updateShippingInfo,
    onCancel,
    openings

    // updateCustomStyle
  } = props;

  // const [openingsToCheck, setOpeningsToCheck] = useState([]);

  // useEffect(() => {
  //   if (openings && openings.domenica) {
  //     setOpeningsToCheck(openings);
  //   }
  // }, [openings]);

  const { t } = useTranslation();

  const classes = useStyles();

  // console.log("openings dentro al componente", openings);

  const isInDateRange = (time, openings) => {
    let isValid = true;
    if (openings.flag_chiuso) {
      return false;
    }
    if (openings.ora_inizio && openings.ora_fine) {
      if (
        moment(time).isBefore(moment(openings.ora_inizio)) ||
        moment(openings.ora_fine).isBefore(moment(time))
      ) {
        isValid = false;
      }
    }
    if (openings.ora_apertura_1 && openings.ora_chiusura_1) {
      // console.log(
      //   "prova adesso sono le",
      //   moment(time).format("H"),
      //   moment(time).format("m"),
      //   Number(moment(time).format("H")) <
      //     Number(moment(openings.ora_apertura_1).format("H"))
      // );
      // console.log(
      //   "apro alle",
      //   moment(openings.ora_apertura_1).format("H"),
      //   moment(openings.ora_apertura_1).format("m")
      // );
      // console.log(
      //   "chiudo alle",
      //   moment(openings.ora_chiusura_1).format("H"),
      //   moment(openings.ora_chiusura_1).format("m")
      // );
      if (
        Number(moment(time).format("H")) <
          Number(moment(openings.ora_apertura_1).format("H")) ||
        Number(moment(time).format("H")) >
          Number(moment(openings.ora_chiusura_1).format("H"))
      ) {
        isValid = false;
      }
      if (
        Number(moment(time).format("H")) ===
          Number(moment(openings.ora_apertura_1).format("H")) &&
        Number(moment(time).format("m")) <
          Number(moment(openings.ora_apertura_1).format("m"))
      ) {
        isValid = false;
      }
      if (
        Number(moment(time).format("H")) ===
          Number(moment(openings.ora_chiusura_1).format("H")) &&
        Number(moment(time).format("m")) >
          Number(moment(openings.ora_chiusura_1).format("m"))
      ) {
        isValid = false;
      }
    }
    if (!isValid && openings.ora_apertura_2 && openings.ora_chiusura_2) {
      if (
        Number(moment(time).format("H")) >
          Number(moment(openings.ora_apertura_2).format("H")) &&
        Number(moment(time).format("H")) <
          Number(moment(openings.ora_chiusura_2).format("H"))
      ) {
        isValid = false;
      }
      if (
        Number(moment(time).format("H")) ===
          Number(moment(openings.ora_apertura_2).format("H")) &&
        Number(moment(time).format("m")) >
          Number(moment(openings.ora_apertura_2).format("m"))
      ) {
        isValid = true;
      }
      if (
        Number(moment(time).format("H")) ===
          Number(moment(openings.ora_chiusura_2).format("H")) &&
        Number(moment(time).format("m")) <
          Number(moment(openings.ora_chiusura_2).format("m"))
      ) {
        isValid = true;
      }
    }
    return isValid;
  };

  const filterPassedTime = time => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    let isValid = true;
    if (openings.ora_inizio && openings.ora_fine) {
      isValid = isInDateRange(time, openings);
    } else {
      switch (time.getDay()) {
        case 0:
          if (openings.domenica) {
            isValid = isInDateRange(time, openings.domenica);
          }
          break;
        case 1:
          if (openings.lunedi) {
            isValid = isInDateRange(time, openings.lunedi);
          }
          break;
        case 2:
          if (openings.martedi) {
            isValid = isInDateRange(time, openings.martedi);
          }
          break;
        case 3:
          if (openings.mercoledi) {
            isValid = isInDateRange(time, openings.mercoledi);
          }
          break;
        case 4:
          if (openings.giovedi) {
            isValid = isInDateRange(time, openings.giovedi);
          }
          break;
        case 5:
          if (openings.venerdi) {
            isValid = isInDateRange(time, openings.venerdi);
          }
          break;
        case 6:
          if (openings.sabato) {
            isValid = isInDateRange(time, openings.sabato);
          }
          break;
        default:
      }
    }
    if (currentDate.getTime() > selectedDate.getTime()) {
      isValid = false;
    }
    return isValid;
    // return currentDate.getTime() < selectedDate.getTime();
  };

  return (
    <>
      {showAlert ? (
        <SweetAlert
          customClass={classes.containerAlert}
          style={{ lineHeight: "normal" }}
          title={""}
          onConfirm={() => {
            onCancel();
          }}
          onCancel={() => {
            onCancel();
            if (alertProps.cancelFunction) {
              alertProps.cancelFunction();
            }
          }}
          closeOnClickOutside={false}
          confirmBtnCssClass={classes.button + " " + classes.success}
          showConfirm={!!(alertProps.showConfirm && shippingInfo.date)}
          // customIcon={alertProps.customIcon}
        >
          <div className={classes.containerAlertBody}>
            {/* <Hidden smDown implementation="css">
              {logo ? (
                <img
                  src={logo}
                  alt="logo"
                  style={{
                    height: "100px",
                    width: "100%",
                    // width: "100px",
                    objectFit: "contain"
                  }}
                />
              ) : null}
            </Hidden> */}
            <h5>{alertProps.title}</h5>
            {/* {ReactHtmlParser(alertProps.description)} */}
            {/* {alertProps && alertProps.customInput ? (
              <CustomInput
                labelText={
                  shippingInfo.type === "bath-house"
                    ? t("shippingAddress.address_bath_house")
                    : t("shippingAddress.address")
                }
                inputProps={{
                  value: address || "",
                  autoComplete: "off",
                  onChange: e => {
                    setAddress(e.target.value);
                  }
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            ) : null} */}
            <div>
              {shippingInfo.date
                ? moment(shippingInfo.date).format("YYYY/MM/DD HH:mm")
                : t("no_data_select")}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                lineHeight: "normal"
              }}
            >
              {/* <Calendar
                locale={language}
                value={shippingInfo.date}
                onChange={date => {
                  const copyShippingInfo = Object.assign({}, shippingInfo, {
                    date
                  });
                  updateShippingInfo(copyShippingInfo);
                }}
                minDate={new Date()}
              /> */}
              <DatePicker
                // locale={language === "en" ? "en-GB" : "it-IT"}
                minDate={
                  openings.ora_inizio
                    ? new Date(moment(openings.ora_inizio).format(""))
                    : new Date()
                }
                maxDate={
                  openings.ora_fine
                    ? new Date(moment(openings.ora_fine).format(""))
                    : null
                }
                selected={shippingInfo.date}
                filterTime={filterPassedTime}
                onChange={date => {
                  const copyShippingInfo = Object.assign({}, shippingInfo, {
                    date
                  });
                  updateShippingInfo(copyShippingInfo);
                }}
                showTimeSelect
                timeIntervals={15}
                timeFormat="HH:mm"
                dateFormat="MMMM d, yyyy h:mm aa"
                inline
                className={classes.l}
              />
            </div>
          </div>
        </SweetAlert>
      ) : null}
    </>
  );
}

CalendarAlert.propTypes = {
  showAlert: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  alertProps: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.any,
    showConfirm: PropTypes.bool,
    cancelFunction: PropTypes.func
  }).isRequired,
  logo: PropTypes.string,
  openings: PropTypes.object,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string,
    timetable: PropTypes.object,
    date: PropTypes.any
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  updateShippingInfo: PropTypes.func.isRequired
};

CalendarAlert.defaultProps = {
  logo: "",
  openings: {}
};
